/* eslint-disable camelcase */
import fr_FR from './fr_FR/'
import en_GB from './en_GB/'

export default {
  'en_GB': en_GB,
  'fr_FR': fr_FR
}



// WEBPACK FOOTER //
// ./src/lang/index.js